

/// <reference path="PaymentDevice.ts" />

// Generated class AdyenPaymentDevice_ManagedObject

class AdyenPaymentDevice_ManagedObject extends PaymentDevice
{
}
